var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-score"},[_c('video',{ref:"video",attrs:{"playsinline":""}}),_c('canvas',{ref:"output"}),_c('ErrorDisplay',{attrs:{"message":{ error: _vm.error }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }